// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"390":"c5880675","461":"68d5d258","757":"5f5ea69e","767":"5d9ef546"}[chunkId] + ".chunk.js";
};